export default __webpack_public_path__ + "static/media/maori.3ff9327a.svg";